export { default as updateAdmin } from './updateAdmin';

export type { AdminUpdateOnSubmitFunction, AdminUpdateOnSubmitPayload } from './updateAdmin.type';
